var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Heap, heapEvent } from '../browser/heap';
import metrics from '../browser/metrics';
var heap = new Heap();
var trackEvent = function (event, data) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            metrics.track(event, data, function (err) {
                if (err)
                    reject(err);
                else
                    resolve();
            });
        }, 0);
    });
};
var trackPage = function () {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            metrics.page(function (err) {
                if (err)
                    reject(err);
                else
                    resolve();
            });
        }, 0);
    });
};
export default function createMetricsPlugin() {
    return {
        name: 'MetricsPlugin',
        plugContext: function (options, context, app) { return ({
            plugComponentContext: function (componentContext) {
                var track = function (event, data) {
                    var _a = data || {}, dwh = _a.dwh, properties = __rest(_a, ["dwh"]);
                    if (heapEvent.includes(event)) {
                        heap.track(event, properties);
                    }
                    else if (!dwh) {
                        trackEvent(event, properties);
                    }
                    if (dwh) {
                        trackEvent(dwh.event, dwh.properties);
                    }
                };
                componentContext.trackEvent = track;
                componentContext.trackPage = trackPage;
            },
            plugActionContext: function (actionContext) {
                actionContext.trackEvent = trackEvent;
                actionContext.trackPage = trackPage;
            },
            dehydrate: function () {
                //
            },
            rehydrate: function (state) { return null; },
        }); },
    };
}
